export enum RouteNames {
  Home = 'Home',

  // Objects pages
  ObjectInfo = 'ObjectInfo',
  ObjectCreate = 'ObjectCreate',
  ObjectSettings = 'ObjectSettings',
  ObjectContent = 'ObjectContent',
  ObjectAnalytics = 'ObjectAnalytics',

  // user pages
  Login = 'Login',
  SignIn = 'SignIn',
  SignInMaster = 'SignInMaster',
  SignInProfile = 'SignInProfile',
  Profile = 'Profile',
  Account = 'Account',
  Users = 'Users',
  User = 'User',
  Join = 'Join',

  // Support pages
  Support = 'Support',

  // Documents page
  Documents = 'Documents',

  // legal pages
  Legals = 'Legals',
  LegalDetail = 'LegalDetail',
  LegalCreate = 'LegalCreate',

  // Contracts pages
  ContractQuota = 'ContractQuota',

  // Tariff pages
  TariffCreate = 'TariffCreate',
  Tariff = 'Tariff',
  TariffInfo = 'TariffInfo',
  TariffSettings = 'TariffSettings',
  TariffPlacingVariantsMaster = 'TariffPlacingVariantsMaster',
  TariffPricesAndRestrictions = 'TariffPricesAndRestrictions',
  TariffServiceGroups = 'TariffServiceGroups',
  TariffQuota = 'TariffQuota',
  TariffsControlled = 'TariffsControlled',

  // Books
  Books = 'Books',
  Book = 'Book',

  // Reconciliation
  Reconciliation = 'Reconciliation',

  // Room categories
  RoomCategories = 'RoomCategories',

  // Channel manager
  CMList = 'CMList',
  CMCreate = 'CMCreate',
  CMEdit = 'CMEdit',

  // other
  Error404 = 'Error404',
  Empty = 'Empty',
  AccessDenied = 'AccessDenied',
  RoleNotAssigned = 'RoleNotAssigned',
}
